import { StateNodeConfig } from '@sierralabs/workflow';

export const sample: StateNodeConfig<Document, any> = {
  name: 'Document Workflow',
  states: [
    {
      name: 'To Do',
      events: [
        {
          name: 'Start Draft',
          transitions: [{ target: 'Draft' }]
        }
      ]
    },
    {
      name: 'Draft',
      events: [
        {
          name: 'Start Review',
          transitions: [{ target: 'In Review' }]
        }
      ]
    },
    {
      name: 'In Review',
      invoke: [
        {
          src: 'createSubTask',
          data: {
            numberOfTasks: 3
          }
        }
      ],
      events: [
        {
          name: 'Approve',
          transitions: [{ target: 'Approved' }]
        }
      ]
    },
    {
      name: 'Approved',
      events: [
        {
          name: 'Start new version',
          transitions: [{ target: 'To Do' }]
        }
      ]
    }
  ]
};
